<template>
  <div class="container"><slot></slot></div>
</template>

<script>
  export default {
    name: 'Container'
  }
</script>

<style lang="scss" scoped>
  .container {
    max-width: 1000px;
    width: 90%;
    margin: 0 auto;
    padding: 0 1rem;

    @media (max-width: 777px) {
      width: 100%;
      padding: 1rem 1.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/container/index.vue